import { Box } from '@mui/material';
import React, { useState } from 'react';
import SwipeableDrawer from '../../../SwipeableDrawer';
import NavIcon from '../../SideNavbar/NavIcon';
import SearchBar from '../../../SearchBar/SearchBar';
import AIAssistantToggler from '../../../AIAssistant/Dialog/AIAssistantToggler';
import { spaces } from '../../../../assets/styles/themes/tokens';

const containerStyles = {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
};

interface MobileTopBarProps {
  shouldShowAIAssistantToggler?: boolean;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({ shouldShowAIAssistantToggler = false }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <Box sx={containerStyles}>
      <NavIcon
        icon='searchNormal'
        onClick={() => setIsDrawerOpen(true)}
      />
      <SwipeableDrawer open={isDrawerOpen} onClose={handleCloseDrawer}>
        <SearchBar closeDrawer={handleCloseDrawer} />
      </SwipeableDrawer>
      <Box sx={{ marginLeft: spaces.xs }}>
        {shouldShowAIAssistantToggler && <AIAssistantToggler />}
      </Box>
    </Box>
  );
};

export default MobileTopBar;
